function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 15,
  fill: "#E2EFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 22C9 23.1 9.9 24 11 24H19C20.1 24 21 23.1 21 22V12C21 10.9 20.1 10 19 10H11C9.9 10 9 10.9 9 12V22ZM12 12H18C18.55 12 19 12.45 19 13V21C19 21.55 18.55 22 18 22H12C11.45 22 11 21.55 11 21V13C11 12.45 11.45 12 12 12ZM18.5 7L17.79 6.29C17.61 6.11 17.35 6 17.09 6H12.91C12.65 6 12.39 6.11 12.21 6.29L11.5 7H9C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9H21C21.55 9 22 8.55 22 8C22 7.45 21.55 7 21 7H18.5Z",
  fill: "#DC3545"
});

function SvgIcRoundDeleteOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundDeleteOutline);
export default __webpack_public_path__ + "static/media/ic_round-delete-outline.208d4cec.svg";
export { ForwardRef as ReactComponent };